import { useCallback } from 'react';

import type { ITableConfigParserOptions } from '../../api/fetchers/tableConfig/types';
import { fetchTableConfigAction } from '../apiActions/fetchTableConfigAction';
import { useCoreDispatch } from '../CoreStore';
import { useConfigSlice } from '../slices/config/selectors';

export const useTableConfigFetcher = (parserOptions: ITableConfigParserOptions, essential: boolean): (() => void) => {
  const dispatch = useCoreDispatch();
  const JSESSIONID = useConfigSlice.JSESSIONID();
  const tableId = useConfigSlice.tableId();
  const baseUrl = useConfigSlice.baseUrl();

  return useCallback((): void => {
    if (JSESSIONID && tableId && baseUrl) {
      dispatch(
        fetchTableConfigAction({
          baseUrl,
          parserOptions,
          params: { JSESSIONID, tableId, operatorNotification: true },
          essential,
        })
      );
    }
  }, [JSESSIONID, baseUrl, dispatch, parserOptions, tableId, essential]);
};
